/**
 * Constants definition.
 *
 * @type {{ACTIVE: string, STOPPED: string, CANCELED: string, DESTROYED: string}}
 */
const EXPEDIENT_STATUS = {
  ACTIVE: 'ACTIVE',
  DISMISS: 'DISMISS',
  ON_DISSOLVE_PROCESS: 'ON_DISSOLVE_PROCESS',
  DISSOLVED: 'DISSOLVED',
  COMPLETED: 'COMPLETED',
  ARCHIVED: 'ARCHIVED',
  CONSTITUTED: 'CONSTITUTED',
  EXPIRED: 'EXPIRED',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const EXPEDIENT_STATUS_ENUM = Object.keys(EXPEDIENT_STATUS);

export {
  EXPEDIENT_STATUS_ENUM,
  EXPEDIENT_STATUS,
};
